// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {BackTop, Button, Card, Col, DatePicker, Input, Modal, Result, Row, Select, Spin, Tabs, Tag} from "antd";
import * as UserBackend from "../../services/UserBackend";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as Setting from "../../conf/Setting";
// import {LinkOutlined} from "@ant-design/icons";
import i18next from "i18next";
import CropperDiv from "../../components/common/CropperDiv.js";
import * as ApplicationBackend from "../../services/ApplicationBackend";
import PasswordModal from "../../components/password/PasswordModal";
import ResetModal from "../../components/user/ResetModal";
// import AffiliationSelect from "./common/AffiliationSelect";
import OAuthWidget from "../../widget/OAuthWidget";
import SamlWidget from "../../widget/SamlWidget";
// import ManagedAccountTable from "./ManagedAccountTable";

import "codemirror/lib/codemirror.css";
import UserTransfer from "../../components/user/UserTransfer";
import UserRoleEditModal from "../../components/user/UserRoleEditModal";
import * as RoleBackend from "../../services/RoleBackend";
import * as Util from "../../utils/Util";

require("codemirror/theme/material-darker.css");
require("codemirror/mode/javascript/javascript");

import GlobalContext from "../../context/GlobalContext";
import * as PasswordPolicyBackend from "../../services/PasswordPolicyBackend";
import moment from "moment";
import * as AuthBackend from "../../services/AuthBackend";
import {JSEncrypt} from "jsencrypt";
import {AppstoreFilled, EditOutlined, TeamOutlined} from "@ant-design/icons";

import "./UserEditPage.less";

const {Option} = Select;
const {TabPane} = Tabs;

class UserEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      organizationId: props.organizationId !== undefined ? props.organizationId : props.match.params.organizationId,
      userName: props.userName !== undefined ? props.userName : props.match.params.userName,
      user: null,
      application: null,
      organizations: [],
      organization: null,
      applications: [],
      mode: props.mode !== undefined ? props.mode :
        (props.location.mode !== undefined ? props.location.mode : "edit"),
      loading: true,
      departments: [],
      userTranferModalVisible: false,
      forbiddenModalVisible: false,
      passwordPolicy: null,
      userTransferConfirmLoading: false,

      roleEditModalVisible: false,
      apps: [],

      defaultActiveKey: "personalInfo",
      loginRedirectUrl: "",
      redirectUrl: "",
    };
  }

  UNSAFE_componentWillMount() {
    this.getUser();
    this.getOrganization();
    if (Setting.isAdminUser(this.props.account)) {
      this.getOrganizations();
      this.getUserApplication();
    } else {
      const params = new URLSearchParams(this.props.location.search);
      const clientId = params.get("client_id");
      const clientSecret = params.get("client_secret");
      const currentTab = params.get("currentTab");
      if (currentTab) {
        this.setState({
          defaultActiveKey: currentTab,
        });
      }

      const loginRedirect = Util.decodeUrl(params.get("login_redirect_url"));
      if (loginRedirect) {
        this.setState({
          loginRedirectUrl: loginRedirect,
        });
      }

      const redirect = params.get("redirect_url");
      if (redirect) {
        this.setState({
          redirectUrl: redirect,
        });
      }
      if (clientId !== null && clientId !== undefined) {
        this.getApplicationByClientId(clientId, clientSecret);
      } else {
        const application = JSON.parse(window.localStorage.getItem("__APPLICATION__"));
        this.setState({
          application: application,
        });
      }
    }
    // this.getApplicationsByOrganization(this.state.organizationId);
    // this.getUserApplication();
  }

  getUser() {
    UserBackend.getUser(this.state.organizationId, this.state.userName)
      .then((data) => {
        if (data.status === null || data.status !== "error") {
          if (this.state.mode === "add") {
            this.setState({
              user: {...data, ...{password: ""}},
            });
          } else {
            this.setState({
              user: data,
            });
          }
          this.getDepartments(data.id);
          this.getUserApps(data.owner, data.id);
        }
        this.setState({
          loading: false,
        });
      }).catch(error => {
      });
  }

  getOrganization() {
    OrganizationBackend.getOrganization(Setting.Admin, this.state.organizationId)
      .then((organization) => {
        this.setState({
          organization: organization,
        });
        PasswordPolicyBackend.getConfig(Setting.Admin, organization.pwdConfig)
          .then(resConfig => {
            if (resConfig.msg === undefined) {
              this.setState({
                passwordPolicy: resConfig,
              });
            } else {
              Setting.showResponseMessage(resConfig.msg);
            }
          });
      });
  }

  getDepartments(userId) {
    UserBackend.getDepartments(userId)
      .then(res => {
        if (res.status === "ok") {
          this.setState({departments: res.data});
        }
      })
      .catch(error => {
      });
  }

  getOrganizations() {
    OrganizationBackend.getOrganizations(Setting.Admin)
      .then((res) => {
        this.setState({
          organizations: (res.msg === undefined) ? res : [],
        });
      });
  }

  getApplicationsByOrganization(organizationId) {
    ApplicationBackend.getApplicationsByOrganization(Setting.Admin, organizationId)
      .then((res) => {
        this.setState({
          applications: (res.msg === undefined) ? res : [],
        });
      });
  }

  getUserApplication() {
    ApplicationBackend.getUserApplication(this.state.organizationId, this.state.userName)
      .then((application) => {
        this.setState({
          application: application,
        });
      });
  }

  getApplicationByClientId(clientId, clientSecret) {
    ApplicationBackend.getApplicationByClientId(clientId, clientSecret)
      .then((application) => {
        this.setState({
          application: application,
        });
      });
  }

  getUserApps(owner, userid) {
    ApplicationBackend.getUserApps(owner, userid)
      .then(res => {
        if (res.status === "ok") {
          this.setState({apps: res.data});
        }
      });
  }

  getReturnUrl() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return searchParams.get("returnUrl");
  }

  parseUserField(key, value) {
    // if ([].includes(key)) {
    //   value = Setting.myParseInt(value);
    // }
    return value;
  }

  updateUserField(key, value) {
    value = this.parseUserField(key, value);

    const user = this.state.user;
    user[key] = value;
    this.setState({
      user: user,
    });
  }

  unlinked() {
    this.getUser();
  }

  isSelf() {
    return (this.state.user.id === this.props.account?.id);
  }

  isSelfOrAdmin() {
    return this.isSelf() || Setting.isAdminUser(this.props.account);
  }

  viewAccountItem(name) {
    const accountItem = this.state.organization?.accountItems.find(accountItem => accountItem.name === name);
    if (!accountItem || !accountItem.visible) {
      return false;
    }

    const isAdmin = Setting.isAdminUser(this.props.account);

    if (accountItem.viewRule === "Self") {
      if (!this.isSelfOrAdmin()) {
        return false;
      }
    } else if (accountItem.viewRule === "Admin") {
      if (!isAdmin) {
        return false;
      }
    }
    if (name === "Password") {
      if (this.state.mode === "edit" && !this.isSelf()) {
        return false;
      }
    }

    if (["Post", "Student status", "Employment status", "Leave date"].includes(name)) {
      if (Setting.isAdminUser(this.state.user)) {
        return false;
      }
    }

    if (["Last login time"].includes(name)) {
      if (this.state.mode === "add") {
        return false;
      }
    }

    if (name === "3rd-party logins") {
      if (this.state.mode === "add" || !this.isSelfOrAdmin()) {
        return false;
      }
    }

    if (["User source", "Roles", "Visit Apps"].includes(name)) {
      if (!Setting.isAdminUser(this.props.account) || this.state.mode === "add" || this.isSelf() || Setting.isAdminUser(this.state.user)) {
        return false;
      }
    }

    return true;
  }

  disabledItemEdit(name) {
    const accountItem = this.state.organization?.accountItems.find(accountItem => accountItem.name === name);
    if (!accountItem || !accountItem.visible) {
      return false;
    }

    const isAdmin = Setting.isAdminUser(this.props.account);

    if (accountItem.modifyRule === "Self") {
      if (!this.isSelfOrAdmin()) {
        return true;
      }
    } else if (accountItem.modifyRule === "Admin") {
      if (!isAdmin) {
        return true;
      }
    } else if (accountItem.modifyRule === "Immutable") {
      return true;
    }

    if (name === "Name" || name === "Email") {
      return this.isSelf();
    }

    return false;
  }

  postLabel() {
    let post = "";
    switch (this.state.user.post) {
    case "0":
      post = i18next.t("general:Unknown");
      break;
    case "1":
      post = i18next.t("本科生辅导员");
      break;
    case "2":
      post = i18next.t("本科生班主任");
      break;
    case "3":
      post = i18next.t("部门秘书");
      break;
    case "4":
      post = i18next.t("分管安全工作领导");
      break;
    case "5":
      post = i18next.t("分管本科生教学领导");
      break;
    default:
      break;
    }
    return post;
  }

  renderUserInfoItem() {
    const isAdmin = Setting.isAdminUser(this.props.account);
    return <>
      {
        !this.viewAccountItem("Name") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "4em" : ""}>
              {Setting.getLabel(i18next.t("user:Name"), i18next.t("user:Name - Tooltip"), true)}：
            </Col>
            <Col span={Setting.isMobile() ? 24 : 22} flex={Setting.isMobile() ? "auto" : ""}>
              <Input value={this.state.user.name} disabled={this.disabledItemEdit("Name")}
                placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)}
                onChange={e => {
                  this.updateUserField("name", e.target.value);
                }}
              />
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Display name") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "3em" : ""}>
              {Setting.getLabel(i18next.t("user:Display name"), i18next.t("user:Display name - Tooltip"), true)}：
            </Col>
            <Col span={Setting.isMobile() ? 24 : 22} flex={Setting.isMobile() ? "auto" : ""}>
              <Input maxLength={50} showCount={isAdmin} disabled={!isAdmin}
                value={this.state.user.displayName}
                placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)}
                onChange={e => {
                  this.updateUserField("displayName", e.target.value);
                }}
              />
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("IdCard") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("user:ID number"), i18next.t("user:ID number - Tooltip"))}：
            </Col>
            <Col span={22} >
              <Input maxLength={18} showCount={true}
                value={this.state.user.idCard}
                placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 18)}
                onChange={e => {
                  this.updateUserField("idCard", e.target.value);
                }} />
              <span style={{marginTop: 5}}>{i18next.t("user:ID number support")}</span>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Avatar") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("general:Avatar"), i18next.t("general:Avatar - Tooltip"))}：
            </Col>
            <Col span={22} style={{marginLeft: Setting.isMobile() ? "20px" : ""}}>
              <Row style={{marginTop: Setting.isMobile() ? "10px" : "20px"}} >
                <Col span={22} >
                  {
                    this.state.user.avatar === "" ?
                      <img src={require("../../assets/images/default_avatar.png")} alt={""} height={90} style={{marginBottom: Setting.isMobile() ? 0 : "20px"}} />
                      :
                      <a target="_blank" rel="noreferrer" href={this.state.user.avatar}>
                        <img src={this.state.user.avatar} alt={""} height={90} style={{marginBottom: Setting.isMobile() ? 0 : "20px"}} />
                      </a>
                  }
                </Col>
              </Row>
              <Row style={{marginTop: Setting.isMobile() ? "10px" : "20px"}}>
                <GlobalContext.Consumer>
                  {
                    ({account, updateAccount}) => (
                      <CropperDiv
                        getNewPicUrl={(url) => {
                          this.updateUserField("avatar", url);
                          if (this.isSelf()) {
                            const newAccount = {...this.props.account, ...{avatar: url}};
                            updateAccount(newAccount);
                          }
                        }}
                        buttonText={`${i18next.t("user:Upload a avatar")}`}
                        title={i18next.t("user:Upload a avatar")}
                        objId={this.state.user.id}
                        account={account}
                        type="user"
                      />
                    )
                  }
                </GlobalContext.Consumer>
              </Row>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Gender") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "3em" : ""}>
              {Setting.getLabel(i18next.t("general:Gender"), i18next.t("general:Gender - Tooltip"))}：
            </Col>
            <Col span={Setting.isMobile() ? 24 : 22} flex={Setting.isMobile() ? "auto" : ""}>
              <Select defaultValue={this.state.user.gender} style={{width: Setting.isMobile() ? "100%" : "98px"}}
                onChange={(value => {this.updateUserField("gender", value);})}>
                <Option value="0">{i18next.t("general:Unknown")}</Option>
                <Option value="1">{i18next.t("general:Male")}</Option>
                <Option value="2">{i18next.t("general:Female")}</Option>
              </Select>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Password") ? null :
          <React.Fragment>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "3em" : ""}>
                {Setting.getLabel(i18next.t("general:Password"), i18next.t("general:Password - Tooltip"), true)}：
              </Col>
              <Col span={Setting.isMobile() ? 24 : 22} flex={Setting.isMobile() ? "auto" : ""}>
                {
                  this.isSelf() ?
                    <PasswordModal user={{...this.state.user, name: this.state.userName}} account={this.props.account}
                      passwordPolicy={this.state.passwordPolicy} organization={this.state.organization} disabled={false} />
                    :
                    <Input.Password
                      value={this.state.user.password}
                      placeholder={i18next.t("user:Please input password")}
                      onChange={e => {
                        this.updateUserField("password", e.target.value);
                      }} />}

              </Col>
            </Row>
            {
              this.isSelf() ? null :
                <Row>
                  <Col offset={2}>
                    <div style={{fontSize: Setting.isMobile() ? 12 : 14, color: "#999999", textAlign: "left", marginBottom: 12}}>
                      {Setting.getPasswordRuleText(this.state.passwordPolicy)}
                    </div>
                  </Col>
                </Row>}
          </React.Fragment>
      }
      {
        !this.viewAccountItem("Email") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "5em" : ""}>
              {Setting.getLabel(i18next.t("general:Email"), i18next.t("general:Email - Tooltip"))}：
            </Col>
            <Col style={{paddingRight: Setting.isMobile() ? 0 : "20px"}} span={Setting.isMobile() ? 24 : 11} flex={Setting.isMobile() ? "auto" : ""}>
              <Input value={this.state.user.email}
                disabled={this.disabledItemEdit("Email")}
                placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)}
                onChange={e => {
                  this.updateUserField("email", e.target.value);
                }} />
            </Col>
            <Col span={Setting.isMobile() ? 24 : 11} style={!Setting.isMobile() ? {} : {marginLeft: "5em", marginTop: "10px"}} flex={Setting.isMobile() ? "8em" : ""}>
              {
                !this.isSelf() ? null : (
                  <ResetModal application={this.state.application}
                    account={this.props.account}
                    disabled={this.disabledItemEdit("Email")}
                    buttonText={i18next.t("user:Reset Email...")}
                    orgin={this.state.user.email}
                    onFinishSubmit={(dest) => {
                      this.updateUserField("email", dest);
                    }}
                    destType={"email"} />
                )
              }
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Phone") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "4em" : ""}>
              {Setting.getLabel(i18next.t("general:Phone"), i18next.t("general:Phone - Tooltip"))}：
            </Col>
            <Col style={{paddingRight: Setting.isMobile() ? 0 : "20px"}} span={Setting.isMobile() ? 24 : 11} flex={Setting.isMobile() ? "auto" : ""}>
              <Input value={this.state.user.phone}
                addonBefore={Setting.isMobile() ? "" : `+${this.state.organization?.phonePrefix}`}
                disabled={this.disabledItemEdit("Phone") || this.isSelf()}
                onChange={e => {
                  this.updateUserField("phone", e.target.value);
                }} />
            </Col>
            {/* <Col span={11} >
              {!this.isSelf() ? null :
                (<ResetModal application={this.state.application}
                  account={this.props.account}
                  disabled={this.disabledItemEdit("Phone")}
                  buttonText={i18next.t("user:Reset Phone...")}
                  orgin={this.state.user.phone}
                  onFinishSubmit={(dest) => {
                    this.updateUserField("phone", dest);
                  }}
                  destType={"phone"} />)}
            </Col> */}
          </Row>

      }
      {
        !this.viewAccountItem("Post") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "3em" : ""}>
              {Setting.getLabel(i18next.t("user:Post"), i18next.t("user:Post - Tooltip"))}：
            </Col>
            <Col style={{paddingRight: Setting.isMobile() ? 0 : "20px"}} span={Setting.isMobile() ? 24 : 11} flex={Setting.isMobile() ? "auto" : ""}>
              <Select defaultValue={this.state.user.post} style={{width: "100%"}}
                onChange={(value => {this.updateUserField("post", value);})}
                disabled={this.isSelf()}>
                <Option value="0">{i18next.t("general:Unknown")}</Option>
                <Option value="1">{i18next.t("本科生辅导员")}</Option>
                <Option value="2">{i18next.t("本科生班主任")}</Option>
                <Option value="3">{i18next.t("部门秘书")}</Option>
                <Option value="4">{i18next.t("分管安全工作领导")}</Option>
                <Option value="5">{i18next.t("分管本科生教学领导")}</Option>
              </Select>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Student status") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("user:Student status"), i18next.t("user:Student status - Tooltip"))}：
            </Col>
            <Col span={22} >
              <Select defaultValue={this.state.user.studentStatus} style={{width: "138px"}}
                onChange={(value => {this.updateUserField("studentStatus", value);})}>
                <Option value="0">{i18next.t("general:Unknown")}</Option>
                <Option value="1">{i18next.t("注册学籍")}</Option>
                <Option value="2">{i18next.t("休学")}</Option>
                <Option value="3">{i18next.t("保留学籍")}</Option>
                <Option value="4">{i18next.t("毕业")}</Option>
                <Option value="5">{i18next.t("退学")}</Option>
              </Select>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Employment status") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("user:Employment status"), i18next.t("user:Employment status - Tooltip"))}：
            </Col>
            <Col span={22} >
              <Select defaultValue={this.state.user.employmentStatus} style={{width: "138px"}}
                onChange={(value => {this.updateUserField("employmentStatus", value);})}>
                <Option value="0">{i18next.t("general:Unknown")}</Option>
                <Option value="1">{i18next.t("在职")}</Option>
                <Option value="2">{i18next.t("离职")}</Option>
                <Option value="3">{i18next.t("退休")}</Option>
              </Select>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Leave date") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("user:Leave date"), i18next.t("user:Leave date - Tooltip"))}：
            </Col>
            <Col span={22} >
              <DatePicker defaultValue={this.state.user.leaveDate === "" ? "" : moment(this.state.user.leaveDate, "YYYY-MM-DD")} onChange={(date, dateString) => {
                this.updateUserField("leaveDate", dateString);
              }} />
            </Col>
          </Row>
      }
    </>;
  }

  renderAccountItem() {
    return <>
      {
        !this.viewAccountItem("Is Active") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 3} flex={Setting.isMobile() ? "5em" : "9em"}>
              {Setting.getLabel(i18next.t("user:Activation state"), i18next.t("usr:Activation state - Tooltip"))}：
            </Col>
            <Col span={Setting.isMobile() ? 24 : 2} flex={Setting.isMobile() ? "auto" : ""}>
              {this.state.user.isActive ?
                <div
                  style={{width: 80, height: 26, backgroundColor: "#2D78D5",
                    color: "#fff", display: "flex", justifyContent: "center", alignItems: "center"}}
                >
                  {i18next.t("user:Active")}
                </div>
                :
                !this.state.organization.needActivation ?
                  <div
                    style={{width: 80, height: 26, backgroundColor: "#2D78D5",
                      color: "#fff", display: "flex", justifyContent: "center", alignItems: "center"}}
                  >
                    {i18next.t("user:Inactive")}
                  </div>
                  :
                  <Button onClick={() => this.activateUser(this.state.user.name, this.state.user.owner)}>{i18next.t("user:Activate")}</Button>
              }
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Created time") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 3} flex={Setting.isMobile() ? "5em" : "9em"}>
              {Setting.getLabel(i18next.t("general:Created time"), i18next.t("general:Created time - Tooltip"))}：
            </Col>
            <Col style={{display: "flex", alignItems: "flex-end"}} span={Setting.isMobile() ? 24 : 21} flex={Setting.isMobile() ? "auto" : ""}>
              <div>{this.state.user.createdTime}</div>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Last login time") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 3} flex={Setting.isMobile() ? "7em" : "9em"}>
              {Setting.getLabel(i18next.t("user:Last signin time"), i18next.t("user:Last signin time - Tooltip"))}：
            </Col>
            <Col style={{display: "flex", alignItems: "flex-end"}} span={Setting.isMobile() ? 24 : 21} flex={Setting.isMobile() ? "auto" : ""}>
              {this.state.user.lastSigninTime}
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("User source") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 3} flex={Setting.isMobile() ? "7em" : "9em"}>
              {Setting.getLabel(i18next.t("user:User source"), i18next.t("user:User source - Tooltip"))}：
            </Col>
            <Col style={{display: "flex", alignItems: "flex-end"}} span={Setting.isMobile() ? 24 : 21} flex={Setting.isMobile() ? "auto" : ""}>
              {this.state.user.userSource}
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("3rd-party logins") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 3}>
              {Setting.getLabel(i18next.t("user:3rd-party logins"), i18next.t("user:3rd-party logins - Tooltip"))}：
            </Col>
            <Col span={21} >
              <div style={{marginBottom: 20}}>
                {
                  (this.state.application === null || this.state.user === null ||
                this.state.application?.providers === null) ? null :
                    (
                      this.state.application?.providers.filter(providerItem => Setting.isProviderVisible(providerItem)).map((providerItem, index) =>
                        (providerItem.provider.category === "OAuth") ? (
                          <OAuthWidget key={providerItem.uid} labelSpan={(Setting.isMobile()) ? 10 : 3} user={this.state.user} application={this.state.application} providerItem={providerItem} account={this.props.account} onUnlinked={() => {return this.unlinked();}} />
                        ) : (
                          <SamlWidget key={providerItem.uid} labelSpan={(Setting.isMobile()) ? 10 : 3} user={this.state.user} application={this.state.application} providerItem={providerItem} onUnlinked={() => {return this.unlinked();}} />
                        )
                      )
                    )
                }
              </div>
            </Col>
          </Row>
      }
    </>;
  }

  renderAffiliation() {
    return <>
      {
        !this.viewAccountItem("Departments") ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 24 : 2} flex={Setting.isMobile() ? "5em" : ""}>
              {Setting.getLabel(i18next.t("user:Departments"), i18next.t("user:Departments - Tooltip"))}：
            </Col>
            <Col style={{marginTop: "5px"}} span={Setting.isMobile() ? 24 : 22} flex={Setting.isMobile() ? "auto" : ""}>
              <Row align="middle" style={{marginBottom: Setting.isAdminUser(this.state.user) || this.isSelf() ? 0 : "4px"}}>
                {
                  Setting.getTags(this.state.departments.map(item => this.isSelf() ? item.displayName : item.wholePath))
                }
              </Row>
              {
                Setting.isAdminUser(this.state.user) || this.isSelf() ? null :
                  <a style={{fontSize: "12px"}} onClick={this.onUserTransfer}><EditOutlined style={{marginRight: 2}} />{i18next.t("user:Transfer departments")}</a>
              }
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Roles") ? null :
          <Row style={{marginTop: "20px", alignItems: "center"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("general:Roles"), i18next.t("general:Roles - Tooltip"))}：
            </Col>
            <Col span={22} >
              <div className="role-edit-tag-container" onClick={() => {
                this.setState({roleEditModalVisible: true});
              }}>
                {
                  this.state.user.roles ?
                    this.state.user.roles.map(role => <Tag icon={<TeamOutlined />} style={{marginTop: 5}} data-roleid={role.uid} key={role.uid} closable={role.isStaticRole}
                      onClose={(e) => {
                        e.preventDefault();
                        const removeId = e.currentTarget.parentNode.dataset.roleid;
                        const roles = this.state.user.roles.filter(range => range.uid !== removeId);
                        this.updateUserField("roles", roles);
                      }}>{role.displayName}{!role.isStaticRole ? `（${i18next.t("user:Dynamic role")}）` : ""}</Tag>)
                    :
                    null
                }
              </div>
            </Col>
          </Row>
      }
      {
        !this.viewAccountItem("Visit Apps") ? null :
          <Row style={{marginTop: "20px", alignItems: "center"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("user:Accessible applications"), i18next.t("user:Accessible applications"))}：
            </Col>
            <Col span={22} >
              {
                this.state.apps ?
                  this.state.apps.map(app => <Tag icon={<AppstoreFilled />} style={{marginTop: 5}} data-roleid={app.appsId} key={app.appsId} closable={false}
                  >{app.appsName}</Tag>)
                  :
                  null
              }
            </Col>
          </Row>
      }
      <UserRoleEditModal visible={this.state.roleEditModalVisible}
        dismiss={() => this.setState({roleEditModalVisible: false})}
        owner={this.state.user.owner}
        userRoles={this.state.user.roles ? this.state.user.roles : []}
        onChangeRole={(selectRoles) => this.updateUserField("roles", selectRoles)}
      />
    </>;
  }

  renderUser(updateAccount) {
    return (
      <Card size="small" title={
        <div>
          {this.state.mode === "add" ? i18next.t("user:New User") : i18next.t("user:Edit User")}&nbsp;&nbsp;&nbsp;&nbsp;
          {!Setting.isMobile() && <Button onClick={() => this.submitUserEdit(false, updateAccount)}>{i18next.t("general:Save")}</Button>}
          <Button style={{marginLeft: "20px"}} type="primary" onClick={() => this.submitUserEdit(true, updateAccount)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} onClick={() => this.deleteUser()}>{i18next.t("general:Cancel")}</Button> :
            <Button style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>}
        </div>
      } style={(Setting.isMobile()) ? {margin: "5px"} : {}} type="inner">
        <Tabs
          tabBarExtraContent={<Row>
            {
              this.state.mode === "add" || Setting.isSuperAdminUser(this.state.user) || Setting.isAdminUser(this.props.account) &&
              !Setting.isSuperAdminUser(this.props.account) || this.isSelf() ?
                null :
                <Button style={{marginRight: "20px"}} disabled={this.state.user.name === Setting.Admin || this.state.user.name === this.props.account.name}
                  onClick={() => {
                    if (!this.state.user.isForbidden) {
                      this.setState({forbiddenModalVisible: true});
                    } else {
                      this.updateUserField("isForbidden", !this.state.user.isForbidden);
                    }
                  }}>{this.state.user.isForbidden ? i18next.t("usr:Enable") : i18next.t("user:Disable")}</Button>
            }
            {
              this.state.mode === "add" || this.isSelf() ? null :
                <PasswordModal user={{...this.state.user, name: this.state.userName}} account={this.props.account}
                  passwordPolicy={this.state.passwordPolicy} organization={this.state.organization} disabled={false} />
            }
          </Row>}
          defaultActiveKey={this.state.defaultActiveKey}
          onChange={(activeKey) => {
          }}
        >
          <TabPane tab={i18next.t("user:Profile")} key="personalInfo" className="tab-pane">
            {
              this.renderUserInfoItem()
            }
          </TabPane>
          <TabPane tab={i18next.t("user:Account")} key="accountInfo" className="tab-pane">
            {
              this.renderAccountItem()
            }
          </TabPane>
          <TabPane tab={i18next.t("user:User base")} key="userBase" className="tab-pane">
            {
              this.renderAffiliation()
            }
          </TabPane>
        </Tabs>
        <BackTop />
      </Card>
    );
  }

  activateUser(name, owner) {
    UserBackend.activateUser(name, owner)
      .then(res => {
        if (res.status === "ok") {
          this.updateUserField("isActive", true);
          Setting.showMessage("success", i18next.t("激活成功"));
        } else {
          Setting.showResponseMessage(res.msg);
        }
      });
  }

  submitUserEdit(willExist, updateAccount) {
    const user = Setting.deepCopy(this.state.user);
    if (user.name.trim() === "") {
      Setting.showMessage("error", i18next.t("user:Please input username"));
      return;
    }

    if (Setting.checkInvalidInputChar(user.name)) {
      Setting.showMessage("error", i18next.t("user:Input username contains invalid character"));
      return;
    }

    if (user.displayName.trim() === "") {
      Setting.showMessage("error", i18next.t("user:Please input display name"));
      return;
    }

    if (user.password.trim() === "") {
      Setting.showMessage("error", i18next.t("user:Please input password"));
      return;
    }

    if (!this.isSelf() && !Setting.isAdminUser(user) && user.idCard !== "") {
      if (user.idCard.length !== 18 && user.idCard.length !== 11 && user.idCard.length !== 9) {
        Setting.showMessage("error", i18next.t("user:Invalid id card type"));
        return;
      }
      if (user.idCard.length === 18 && !Setting.isValidIdCard(user.idCard)) {
        Setting.showMessage("error", i18next.t("user:Invalid id card number"));
        return;
      }
      if (user.idCard.length === 11 && !Setting.isValidGAPassport(user.idCard)) {
        Setting.showMessage("error", i18next.t("user:Invalid passport number of Hongkong, Macao or Taiwan"));
        return;
      }
      if (user.idCard.length === 9 && !Setting.isValidPassport(user.idCard)) {
        Setting.showMessage("error", i18next.t("user:Invalid passport"));
        return;
      }
    }

    if (user.name.length > 50) {
      Setting.showMessage("error", i18next.t("user:Name is limited in 50 characters"));
      return;
    }
    if (user.displayName.length > 50) {
      Setting.showMessage("error", i18next.t("user:Display name is limited in 50 characters"));
      return;
    }
    if (user.email.length > 50) {
      Setting.showMessage("error", i18next.t("user:Email is limited in 50 characters"));
      return;
    }

    if (user.phone.length > 0 && !Setting.isValidPhone(user.phone)) {
      Setting.showMessage("error", i18next.t("general:Input phone is not valid"));
      return;
    }

    if (user.email.length > 0 && !Setting.isValidEmail(user.email)) {
      Setting.showMessage("error", i18next.t("general:Input email is not valid"));
      return;
    }

    if (this.state.mode === "add") {
      AuthBackend.getPublicKey().then(resPubKey => {
        if (resPubKey.status === "ok") {
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(resPubKey.msg);
          const newEncryptPassword = encrypt.encrypt(user.password);
          user["password"] = newEncryptPassword;
          UserBackend.updateUser(this.state.organizationId, this.state.userName, user)
            .then(async(res) => {
              if (res.msg === "") {
                const roles = this.state.user.roles ? this.state.user.roles.map(item => ({roleId: item.uid, roleName: item.displayName})) : [];

                if (Setting.isAdminUser(this.props.account) && !this.isSelf()) {
                  const resRoles = await RoleBackend.setUserRoles(this.state.user.owner, this.state.user.id, roles);
                  if (resRoles.status !== "ok") {
                    Setting.showResponseMessage(resRoles.msg);
                    return;
                  }
                }
                Setting.showMessage("success", i18next.t("general:Successfully saved"));
                this.setState({
                  userName: this.state.user.name,
                });

                if (this.isSelf()) {
                  updateAccount({...this.props.account, ...{displayName: this.state.user.displayName}});
                }

                if (this.props.history !== undefined) {
                  if (willExist) {
                    if (this.state.loginRedirectUrl) {
                      Setting.goToLink(this.state.loginRedirectUrl);
                      return;
                    }
                    if (this.state.redirectUrl) {
                      Setting.goToLink(this.state.redirectUrl);
                      return;
                    }

                    if (this.isSelf()) {
                      this.props.history.goBack();
                    }
                    this.props.history.push("/users");
                  } else {
                    this.setState({mode: "edit"});
                    this.props.history.replace(`/users/${this.state.user.owner}/${this.state.user.name}`);
                  }
                }
              } else {
                Setting.showResponseMessage(res.msg);
                this.updateUserField("owner", this.state.organizationId);
                this.updateUserField("name", this.state.userName);
              }
            })
            .catch(error => {
              Setting.showResponseMessage(error);
            });
        } else {
          Setting.showResponseMessage(resPubKey.msg);
        }
      });
    } else {
      UserBackend.updateUser(this.state.organizationId, this.state.userName, user)
        .then(async(res) => {
          if (res.msg === "") {
            const roles = this.state.user.roles ? this.state.user.roles.map(item => ({roleId: item.uid, roleName: item.displayName})) : [];
            if (Setting.isAdminUser(this.props.account) && !this.isSelf()) {
              const resRoles = await RoleBackend.setUserRoles(this.state.user.owner, this.state.user.id, roles);
              if (resRoles.status !== "ok") {
                Setting.showResponseMessage(resRoles.msg);
                return;
              }
            }
            Setting.showMessage("success", i18next.t("general:Successfully saved"));
            this.setState({
              userName: this.state.user.name,
            });

            if (this.isSelf()) {
              updateAccount({...this.props.account, ...{displayName: this.state.user.displayName}});
            }

            if (this.props.history !== undefined) {
              if (willExist) {
                if (this.state.loginRedirectUrl) {
                  Setting.goToLink(this.state.loginRedirectUrl);
                  return;
                }

                if (this.state.redirectUrl) {
                  Setting.goToLink(this.state.redirectUrl);
                  return;
                }

                if (this.isSelf()) {
                  this.props.history.goBack();
                  return;
                }
                this.props.history.push("/users");
              } else {
                if (this.state.loginRedirectUrl) {
                  window.location.reload();
                  return;
                }
                this.props.history.replace(`/users/${this.state.user.owner}/${this.state.user.name}`);
              }
            }

          } else {
            Setting.showResponseMessage(res.msg);
            this.updateUserField("owner", this.state.organizationId);
            this.updateUserField("name", this.state.userName);
          }
        })
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    }

  }

  deleteUser() {
    const user = {...this.state.user, ...{name: this.state.userName}};
    UserBackend.deleteUser(user)
      .then(() => {
        this.props.history.push("/users");
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  }

  exit() {
    if (this.state.loginRedirectUrl) {
      Setting.goToLink(this.state.loginRedirectUrl);
    } else if (this.state.redirectUrl) {
      Setting.goToLink(this.state.redirectUrl);
    } else {
      this.props.history.goBack();
    }
  }

  onUserTransfer = () => {
    this.setState({
      userTranferModalVisible: true,
    });
  };

  onTranferUsers(transferedNodes) {
    const userIds = this.state.user?.id ? [this.state.user.id] : [];
    const organIds = transferedNodes.map(node => {
      return node.level === 0 ? node.uid : node.organId;
    });
    // 去重
    const organIdsRemoveDup = organIds.filter((item, index) => {
      return organIds.indexOf(item) === index;
    });
    // 不允许用户在多个组织
    if (organIdsRemoveDup.length > 1) {
      Setting.showMessage("error", i18next.t("user:User can't be assigned to different organizations"));
      return;
    }
    const newOrganId = organIdsRemoveDup[0] !== this.state.organizationId ? organIdsRemoveDup[0] : "";
    const transferDepts = transferedNodes.map(node => {
      return {
        deptId: node.uid, // 当前部门或组织的uid （必填）
        isDept: node.level === 0 ? false : true, // 是组织还是部门 0组织, 1部门 (必填)
        displayName: node.displayName,
      };
    });
    this.setState({userTransferConfirmLoading: true});
    UserBackend.updateDepartments(userIds, transferDepts, newOrganId)
      .then(res => {
        this.setState({userTransferConfirmLoading: false});
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully saved"));
          this.setState({userTranferModalVisible: false});
          this.getDepartments(this.state.user.id);
          if (newOrganId !== undefined && newOrganId !== "") {
            this.setState({organizationId: newOrganId});
            this.updateUserField("owner", newOrganId);
          }
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        this.setState({userTransferConfirmLoading: false});
        Setting.showResponseMessage(error);
      });
  }

  render() {
    return (
      <GlobalContext.Consumer>
        {
          ({account, updateAccount}) => (
            <div>
              {
                this.state.loading ? <Spin size="large" /> : (
                  this.state.user !== null ? this.renderUser(updateAccount) :
                    <Result
                      status="404"
                      title="404 NOT FOUND"
                      subTitle={i18next.t("general:Sorry, the user you visited does not exist or you are not authorized to access this user.")}
                      extra={<a href="/"><Button type="primary">{i18next.t("general:Back Home")}</Button></a>}
                    />
                )
              }
              {
                this.state.user === null ? null :
                  <div style={{marginTop: "20px", marginLeft: Setting.isMobile() ? 0 : "40px"}}>
                    {!Setting.isMobile() && <Button size="large" onClick={() => this.submitUserEdit(false, updateAccount)}>{i18next.t("general:Save")}</Button>}
                    <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitUserEdit(true, updateAccount)}>{i18next.t("general:Save & Exit")}</Button>
                    {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} size="large" onClick={() => this.deleteUser()}>{i18next.t("general:Cancel")}</Button> :
                      <Button size="large" style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>}
                  </div>
              }
              <Col span={24}>
                <UserTransfer visible={this.state.userTranferModalVisible}
                  dismiss={() => this.setState({userTranferModalVisible: false})}
                  confirmLoading={this.state.userTransferConfirmLoading}
                  onConfirmSelect={(transferedNodes) => {
                    this.onTranferUsers(transferedNodes);
                  }} />
              </Col>
              <Modal
                title={i18next.t("user:Forbidden Account")}
                visible={this.state.forbiddenModalVisible}
                okText={i18next.t("general:Confirm")}
                cancelText={i18next.t("general:Cancel")}
                onOk={() => {
                  this.updateUserField("isForbidden", true);
                  this.setState({forbiddenModalVisible: false});
                }}
                onCancel={() => {this.setState({forbiddenModalVisible: false});}}
              >
                <div style={{marginLeft: "30px"}}>
                  <p>{i18next.t("user:Sure to forbbiden this account")}?</p>
                  <p>1.{i18next.t("user:Forbidden Account Description1")}</p>
                  <p>2.{i18next.t("user:Forbidden Account Description2")}</p>
                  <p>3.{i18next.t("user:Forbidden Account Description3")}</p>
                </div>
              </Modal>
            </div>
          )
        }
      </GlobalContext.Consumer>
    );
  }
}

export default UserEditPage;
